import { ENDPOINT_IFP_UPDATE_APPLICATION, IfpUpdateApplicationRequest } from '@shared/sec-loans'
import { callEndpoint } from '@ui-common/utils'

export const updateIfpApplication = (
  requestPayload: IfpUpdateApplicationRequest,
  applicationId: string,
): Promise<void> =>
  callEndpoint(ENDPOINT_IFP_UPDATE_APPLICATION, {
    pathParams: {
      applicationId,
    },
    requestPayload,
  })
